import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-userdefinedspinner',
    templateUrl: './userdefinedspinner.component.html',
    styleUrls: ['./userdefinedspinner.component.scss'],
    standalone: false
})
export class UserdefinedspinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
